import viewStateVar from 'src/store/viewState';

export const useResetSelectedState = (): (() => void) => {
  return () => {
    viewStateVar({
      ...viewStateVar(),
      isSelectAll: false,
      selectedAssets: [],
    });
  };
};
